<template>
  <v-menu
    v-model="isOpenMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="date"
        :label="label"
        prepend-icon="mdi-calendar"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" :max="maxDate" @input="inputHandler">
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment';

export default {
  name: 'HistoryDatepickerField',
  props: {
    modeSelection: {
      type: String,
      default: 'day'
    },
    isStart: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpenMenu: false,
      maxDate: '',
      date: ''
    };
  },
  methods: {
    inputHandler(e) {
      this.isOpenMenu = false;
      this.$emit('input', this.date);
    }
  },
  watch: {
    modeSelection: {
      handler: function() {
        if (this.isStart) {
          if (this.modeSelection === 'day') {
            this.date = moment().format('YYYY-MM-DD');
          } else if (this.modeSelection === 'week') {
            this.date = moment()
              .subtract(1, 'weeks')
              .format('YYYY-MM-DD');
          } else if (this.modeSelection === 'month') {
            this.date = moment()
              .subtract(1, 'months')
              .format('YYYY-MM-DD');
          }
        } else {
          this.date = moment().format('YYYY-MM-DD');
        }
        this.$emit('input', this.date);
      },
      immediate: true
    }
  },
  mounted() {
    this.maxDate = moment().format('YYYY-MM-DD');
  }
};
</script>
